
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/agent-training",
      function () {
        return require("private-next-pages/portal/agent-training.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/agent-training"])
      });
    }
  